(app => {

    app.component("accountDirectoryBtn",
        {
            template: `
                <md-button class="md-icon-button btn-accent" ng-click="$ctrl.openDirectory({ $event: $event })">
                    <md-icon md-font-icon="mdi mdi-24px mdi-folder" aria-label="Open File Viewer"></md-icon>
                    <md-tooltip md-delay="500">View Account Files</md-tooltip>
                </md-button>
            `,
            bindings: {
                openDirectory: "&",
            }
        });

})(window.app);